import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor(private authService: AuthService) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (!this.authService.hasRefreshToken()) {
            this.authService.navigateToDiscoveryPage();
            return of(false);
        }

        if (!this.authService.hasAccessToken()) {
            return this.authService.refreshTokens().pipe(
                map(() => {
                    return this.authService.hasAccessToken();
                }),
            );
        }

        return of(true);
    }
}
